import 'intl';
import 'intl/locale-data/jsonp/en-IN';
import 'intl/locale-data/jsonp/en';

const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' });
const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

const NumberFormat = new Intl.NumberFormat('en-IN');
const QuantityFormat = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 3 });
const PercentFormat = new Intl.NumberFormat('en-IN', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 });

const formatPrice = (value, currency) => {
  if (currency === 'USD') return usd.format(value);
  if (currency === 'INR') return inr.format(value);
  return 'No Currency';
};

const formatTransport = (value) => {
  return value;
};

const formatRefNo = (value, prefix = 'BF') => {
  if (value) {
    return `${prefix}${String(value).padStart(4, '0')}`;
  }
  return value;
};

const formatNumber = (value) => {
  return NumberFormat.format(value);
};

const formatQuantity = (value = 0) => {
  const returnValue = Number.isInteger(value) ? value : QuantityFormat.format(value);
  return returnValue;
};

const formatPercent = (value) => {
  return PercentFormat.format(value);
};

export { formatPrice, formatTransport, formatRefNo, formatNumber, formatQuantity, formatPercent };
